import React,{useEffect,useState} from 'react'
import {useParams} from 'react-router-dom'
import {Box} from '@mui/material'
import {exerciseOptions,fetchData, youtubeOptions} from '../utils/fetchdata'
import Details from '../component/Details'
import ExerciseVideo from '../component/ExerciseVideo'
import SimilarExercises from '../component/SimilarExercises'
const ExerciseDetails = () => {
  const [exerciseDetail,setExerciseDetail]=useState({});
  const[exerciseVideo,setExerciseVideo]=useState([]);
  const [targetMuscleExercises,setTargetMuscleExercises]=useState([]);
const [equipmentExercises,setEquipmentExercises]= useState([]);
  const {id}=useParams();
  useEffect(()=>{
const fetchExercisesData=async()=>{
const exerciseDbUrl='https://exercisedb.p.rapidapi.com';
const youtubeSearchUrl = 'https://youtube-search-and-download.p.rapidapi.com';
const exerciseDetailData = await fetchData(`${exerciseDbUrl}/exercises/exercise/${id}`,exerciseOptions);
//this will give the informstion about the selected exercise
setExerciseDetail(exerciseDetailData);

// 2nd API Call
const exerciseVideosData=await fetchData(`${youtubeSearchUrl}/search?query=${exerciseDetailData.name}`,youtubeOptions)
// This is willgive the video about the particular option
setExerciseVideo(exerciseVideosData.contents); //exerciseVideoData k andar k contents m pada h video

const targetMuscleExercisesData=await fetchData(`${exerciseDbUrl}/exercises/target/${exerciseDetailData.target}`,exerciseOptions) //we want similar exercises that target the specific exercise
setTargetMuscleExercises(targetMuscleExercisesData);

const equipmentExercisesData=await fetchData(`${exerciseDbUrl}/exercises/equipment/${exerciseDetailData.equipment}`,exerciseOptions) //we want similar exercises that target the specific equipment
setEquipmentExercises(equipmentExercisesData);
console.log(equipmentExercises);
}
fetchExercisesData();
  },[id]); //[id]-dependency array= meaning call this function whenever the id changes
  return (
    <Box>
      <Details exerciseDetail={exerciseDetail}/>
      <ExerciseVideo exerciseVideo={exerciseVideo} name={exerciseDetail.name}/>
      {/* <SimilarExercises targetMuscleExercises={targetMuscleExercises}  */}
      {/* equipmentExercises={equipmentExercises}/> */}
    </Box>
  )
}

export default ExerciseDetails